import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import { config } from '../../../config';
import { LocalStorageKeys } from "../../../utils";
import jwt_decode from "jwt-decode";
// Create our baseQuery instance
const baseQuery = fetchBaseQuery({
    baseUrl: config.api_url,
    prepareHeaders: (headers, { getState }) => {
        // By default, if we have a token in the store, let's use that for authenticated requests
        const token = localStorage.getItem(LocalStorageKeys.authToken);
        if (token) {
            let client = jwt_decode(token)?.selected_client
            let slug = client?.tenants?.slug

            headers.set("Authorization", "Bearer " + token);
            headers.set("x-build-code", config?.xbuildCode);
            headers.set("Slug", slug);
            headers.set("'Access-Control-Allow-Origin'", "*");

        }
        return headers;
    },
});

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 0 });;
export const FileManagerAPI = createApi({
    reducerPath: "FileManagerAPI",
    baseQuery: baseQueryWithRetry,
    tagTypes: ['filemanager'],

    endpoints: (builder) => ({
        // property access directories
        GetPropertyAccess: builder.query({
            query: (payload) => ({
                url: `asset_management/property_access_directories`,
                method: "POST",
                body: payload
            }),
            transformResponse: (response, meta, arg) => {
                if (response?.type === "success") {
                    return response;
                }
                return [];
            },
        }),
        // get documents
        GetViewDocuments: builder.query({
            query: (payload) => ({
                url: `asset_management/fetch`,
                method: "POST",
                body: payload
            }),
            transformResponse: (response, meta, arg) => {
                if (response?.type === "success") {
                    return response;
                }
                return [];
            },
        }),

    }),
})

// Export hooks for usage in functional components
export const { useLazyGetPropertyAccessQuery, useLazyGetViewDocumentsQuery } = FileManagerAPI;
